export const UF_OPTIONS = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES",
  "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR",
  "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC",
  "SP", "SE", "TO",
];

export const HOW_HEARD_OPTIONS = [
  { value: "google", label: "Google" },
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "tiktok", label: "TikTok" },
  { value: "youtube", label: "YouTube" },
  { value: "indicacao", label: "Indicação" },
  { value: "ifood", label: "iFood" },
  { value: "evento", label: "Evento" },
  { value: "outro", label: "Outro" },
];

export const EMPTY_RESTAURANT = {
  name: "",
  ifood_link_or_id: "",
  uses_delivery_direto: false,
  uses_neemo: false,
};

export const LGPD_TEXT = `TERMOS DE USO E POLÍTICA DE PRIVACIDADE - SLAPIE

Ao preencher este formulário, você declara estar ciente e de acordo com os seguintes termos:

1. COLETA DE DADOS
Os dados informados neste formulário (nome, e-mail, telefone, CPF/CNPJ, endereço e informações do negócio) serão coletados e armazenados pela Slapie exclusivamente para fins de contato comercial e análise de viabilidade de parceria.

2. FINALIDADE
Seus dados serão utilizados para:
- Entrar em contato sobre os serviços da Slapie;
- Avaliar a compatibilidade do seu negócio com nossa plataforma;
- Enviar informações relevantes sobre nossos produtos e serviços.

3. COMPARTILHAMENTO
Seus dados NÃO serão compartilhados, vendidos ou cedidos a terceiros sem o seu consentimento prévio, exceto quando exigido por lei.

4. ARMAZENAMENTO E SEGURANÇA
Seus dados serão armazenados em servidores seguros com criptografia e controles de acesso. Manteremos seus dados pelo período necessário para a finalidade descrita ou conforme exigido por lei.

5. SEUS DIREITOS (LEI Nº 13.709/2018 - LGPD)
Você tem direito a:
- Solicitar acesso aos seus dados pessoais;
- Solicitar correção de dados incompletos ou desatualizados;
- Solicitar a exclusão dos seus dados;
- Revogar este consentimento a qualquer momento.

Para exercer seus direitos, entre em contato pelo e-mail: privacidade@slapie.com.br

6. CONSENTIMENTO
Ao marcar a caixa "Li e aceito os Termos de Uso e Política de Privacidade", você consente com a coleta e uso dos seus dados conforme descrito acima.

Versão 1.0 - Fevereiro/2026`;

export const INITIAL_QUICK_DATA = {
  full_name: "",
  whatsapp: "",
  restaurant_name: "",
};

export const INITIAL_DETAILS_DATA = {
  email: "",
  cpf_cnpj: "",
  business_name: "",
  city: "",
  uf: "",
  restaurants: [],
  address_street: "",
  address_number: "",
  address_complement: "",
  address_neighborhood: "",
  address_city: "",
  address_uf: "",
  address_cep: "",
  how_heard: "",
  message: "",
  lgpd_consent: false,
};
